angular.module('rjmNg.directives').directive "ageCalculation", [
  () ->
    restrict: "E"
    templateUrl: "directive.ageCalculation.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      sourceColumn: "="
      tableId: "="
    controller: [
      () ->
        view = @
        view.dateTimeType = ["inst"]

        @$onInit = ->
          view.sourceColumn ?=
            table: view.tableId
            column: view.sourceColumn

        return view
    ]
]
